var _defs, _path, _g, _rect, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-5{stroke-width:4px;}.cls-6{stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-1",
    d: "M56.94,0A56.95,56.95,0,1,1,0,56.94,56.94,56.94,0,0,1,56.94,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_151",
    "data-name": "Path 151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,109.45A51.63,51.63,0,0,1,20,21.27a51.68,51.68,0,0,1,84.12,16.42,51.62,51.62,0,0,1-47.6,71.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.53,8.14a49.67,49.67,0,0,0-19.32,95.41A49.67,49.67,0,0,0,75.86,12a49.31,49.31,0,0,0-19.33-3.9m0-4A53.66,53.66,0,1,1,2.88,57.8,53.65,53.65,0,0,1,56.53,4.14Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-4",
    x: 32.02,
    y: 30.21,
    width: 48.82,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-5",
    d: "M78.78,75a25.92,25.92,0,1,1-2-36.6,25.17,25.17,0,0,1,2.89,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M64.47,65.57A5.48,5.48,0,1,1,59,60.09h0a5.48,5.48,0,0,1,5.48,5.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-6",
    d: "M45.37,57.66A17.06,17.06,0,0,1,54.94,51c6.24-1.55,13.08.91,17.67,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-6",
    d: "M45.37,48.07a17.06,17.06,0,0,1,9.57-6.7c6.24-1.55,13.08.91,17.67,6.26"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-4",
    x: 32.02,
    y: 30.21,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/Icon9.f5e63425368cd19a89f0d92687c7f48e.svg";
export { ForwardRef as ReactComponent };